import http from "../http-common";
import authHeader from './auth-header';

class UploadFilesService {
  uploadImage(file, onUploadProgress) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", file);

    return http.post("/uploadImage", formData, {headers: customHeaders,
      onUploadProgress
    });
  }

  uploadKYCFile(data, onUploadProgress) {
    const customHeaders = authHeader()

    customHeaders["Content-Type"] = "multipart/form-data";

    let formData = new FormData();

    formData.append("file", data.file);
    formData.append("json", JSON.stringify(data.json));

    return http.post("/uploadKYCFile", formData, {headers: customHeaders,
      onUploadProgress
    });
  }

  deleteKYCFile(data) {
    return http.put(`/deleteKYCFile`, data, { headers: authHeader() });
  }

  getFiles() {
    return http.get("/files");
  }

  getImages() {
    return http.get('/images', { headers: authHeader() });
  }

  setCurrent(id) {
    return http.put(`/update_images/${id}`, { headers: authHeader() });
  }
}

export default new UploadFilesService();